/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_ImproveInputs */

const en_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room to improve`)
};

const de_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbesserungspotenzial`)
};

const fr_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des améliorations possibles`)
};

const es_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margen de mejora`)
};

const it_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margine di miglioramento`)
};

const nl_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruimte voor verbetering`)
};

const pl_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole do poprawy`)
};

const fi_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parantamisen varaa`)
};

const da_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plads til forbedring`)
};

const sv_onboarding_ats_score_improve = /** @type {(inputs: Onboarding_Ats_Score_ImproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utrymme för förbättring`)
};

/**
* | output |
* | --- |
* | "Room to improve" |
*
* @param {Onboarding_Ats_Score_ImproveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_improve = /** @type {((inputs?: Onboarding_Ats_Score_ImproveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_ImproveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_improve(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_improve(inputs)
	if (locale === "es") return es_onboarding_ats_score_improve(inputs)
	if (locale === "it") return it_onboarding_ats_score_improve(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_improve(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_improve(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_improve(inputs)
	if (locale === "da") return da_onboarding_ats_score_improve(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_improve(inputs)
	return en_onboarding_ats_score_improve(inputs)
});